import * as React from 'react'

interface LMDoneSquareProps {
  className?: string
  width?: number | string
  height?: number | string
}

const LMDoneSquare: React.FC<LMDoneSquareProps> = ({
  className = '',
  width = 18,
  height = 18
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-square-check-big-icon lucide-square-check-big ${className}`}
  >
    <path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344" />
    <path d="m9 11 3 3L22 4" />
  </svg>
)

export default LMDoneSquare
